// noinspection DuplicatedCode

import React, { useEffect, useState } from "react";

import { Colors } from "../../../assets/Colors";
import { fetchGet, fetchPost, fetchPut } from "../../../fetchers";
import { useMutation } from "@tanstack/react-query";
import { DynamicTableSimple } from "../../../components/tablecard/DynamicTable";
import { Card } from "@material-tailwind/react";
import { isRequired, useForm } from "../../../components/isRequired";
import { HrdInputGenerator } from "../../../components/form/HrdInputGenerator";
import "react-toastify/dist/ReactToastify.css";
import { BiArrowBack, BiPrinter } from "react-icons/bi";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Select from "react-select";
import Skeltons from "../../../components/loading/Skeltons";
import { Currency, Top } from "../purchase-requisition/configuration";
import DatePicker from "react-datepicker";

const DeletePurchaseComparationPage = ({}) => {
  let initialState = {
    SupplierCount: 0,
    BisnisUnitID: "U0002",
  };

  const validations = [
    ({ UserPCName }) =>
      isRequired(UserPCName) || { UserPCName: "Nama UserPC wajib diisi" },
    ({ Status }) => isRequired(Status) || { Status: "Status wajib diisi" },
    ({ KelompokID }) =>
      isRequired(KelompokID) || { KelompokID: "Kelompok wajib diisi" },
    ({ Status }) => isRequired(Status) || { Status: "Kelompok wajib diisi" },
    ({ DetailAccountID }) =>
      isRequired(DetailAccountID) || {
        DetailAccountID: "Detail Account wajib diisi",
      },
    ({ Status }) =>
      isRequired(Status) || { Status: "Detail Account wajib diisi" },
  ];

  const { values, touched, customHandler, changeHandler, errors, editHandler } =
    useForm(initialState, validations);

  const [buttonTouched, setButtonTouched] = useState(false);
  const [detail, setDetail] = useState([]);
  const [showModal, setShowModal] = useState(false);

  const [prData, setPRData] = useState([]);
  const [barang, setBarang] = useState([]);
  const [pRListComparison, setPRListComparison] = useState([]);
  const [showDetail, setshowDetail] = useState(true);
  const [generalTotal, setGeneralTotal] = useState(0);

  const barangDetail = useMutation((formData) => fetchGet("Master/Barang/min"));
  const [supplierSelected, setSupplierSelected] = useState(1);

  const ModalOpener = (detail) => {
    setShowModal(true);
  };
  const mutationAdd = useMutation((formData) =>
    fetchPost("Procurement/PriceComparison/approval/send", formData)
  );
  const mutationSave = useMutation((formData) =>
    fetchPut("Procurement/PriceComparison/batal", formData)
  );

  const PurchaseRequisition = useMutation((formData) =>
    fetchPost("Procurement/PurchaseRequisition/min", formData)
  );
  const PurchaseRequisitionDetail = useMutation((formData) =>
    fetchGet("Procurement/PurchaseRequisition/" + formData)
  );
  const franco = useMutation((formData) => fetchGet("Master/Franco/min"));
  const PriceComparison = useMutation((formData) =>
    fetchGet("Procurement/PriceComparisonMon/" + formData)
  );
  const param = useLocation();
  const params = useParams();

  const mutationUpdate = useMutation((formData) =>
    fetchPost("Procurement/PriceComparison/approval/update", formData)
  );

  const navigate = useNavigate();

  useEffect(() => {
    barangDetail.mutate();
    PurchaseRequisition.mutate({ BisnisUnitID: params.id });
    franco.mutate();
    if (params.transid) {
      PriceComparison.mutate(params.transid.replaceAll("-", "/"));
    }
  }, []);

  useEffect(() => {
    if (prData && params.transid) {
      const index = prData.findIndex(
        (x) => x.PurchaseRequisitionID === params.msr.replaceAll("-", "/")
      );
      customHandler(index, "PurchaseRequisitionID");
    }
    if (params.msr) {
      PurchaseRequisitionDetail.mutate(params.msr.replaceAll("-", "/"));
    }
  }, [prData]);

  useEffect(() => {
    if (mutationUpdate) {
      if (mutationUpdate.isSuccess) {
        navigate("/approval-list");
      }
    }
  }, [mutationUpdate.status]);

  useEffect(() => {
    if (PurchaseRequisitionDetail.data) {
      setBarang(PurchaseRequisitionDetail.data.data.PRList);
    }
  }, [PurchaseRequisitionDetail.data]);

  useEffect(() => {
    if (PriceComparison.data) {
      const tempArray = PriceComparison.data.data;
      if (tempArray && tempArray[0]["PurchaseRequisitionID"]) {
        customHandler(tempArray.length, "SupplierCount");
        for (let selected = 0; selected < tempArray.length; selected++) {
          if (tempArray[selected]["PRListComparison"])
            for (
              let i = 0;
              i < tempArray[selected]["PRListComparison"].length;
              i++
            ) {
              // Gabungkan data berdasarkan PRListID, BUKAN urutan baris: harga
              // dari backend tak berurutan & daftar MSR bisa memuat barang yang
              // tak ada di PC, sehingga pasangan per indeks menampilkan harga di
              // samping barang yang salah (kasus 01736/PC/SO/09/2026).
              const prRow = (PurchaseRequisitionDetail.data.data.PRList || []).find(
                (p) => String(p.PRListID) === String(tempArray[selected]["PRListComparison"][i]["PRListID"])
              );
              tempArray[selected]["PRListComparison"][i] = {
                ...tempArray[selected]["PRListComparison"][i],
                ...(prRow || {}),
              };
              tempArray[selected]["PRListComparison"][i]["TotalHarga"] =
                tempArray[selected]["PRListComparison"][i]["Harga"] *
                tempArray[selected]["PRListComparison"][i]["Qty"];
              let totals = 0;
              for (
                let j = 0;
                j < tempArray[selected]["PRListComparison"].length;
                j++
              ) {
                let sum = 0;
                if (tempArray[selected]["PRListComparison"][j]["TotalHarga"]) {
                  sum = parseInt(
                    tempArray[selected]["PRListComparison"][j]["TotalHarga"]
                  );
                }
                totals = totals + sum;
              }
              tempArray[selected]["Total"] = totals;
              let disc = parseInt(tempArray[selected]["DiscountPercent"]);
              let PPNTotal = 0.0;
              let PPHTotal = 0.0;
              let PBBKBTotal = 0.0;
              let discounds = 0.0;
              if (!disc || disc === 0) {
                if (tempArray[selected]["DiscountRupiah"] > 0) {
                  discounds =
                    totals - parseInt(tempArray[selected]["DiscountRupiah"]);
                }
              } else {
                discounds =
                  parseInt(tempArray[selected]["DiscountRupiah"]) +
                  (parseInt(totals) -
                    parseInt(totals) *
                      (parseInt(tempArray[selected]["DiscountPercent"]) / 100));
                discounds = parseFloat(totals - parseInt(discounds)).toFixed(2);
              }
              tempArray[selected]["Discound"] = discounds;
              totals = parseInt(parseInt(totals) - parseInt(discounds));

              tempArray[selected]["Total2"] = totals;

              if (parseInt(tempArray[selected]["PPN"]) > 0) {
                PPNTotal = parseFloat(
                  totals -
                    (totals -
                      (totals * parseInt(tempArray[selected]["PPN"])) / 100)
                ).toFixed(2);
              }
              if (parseInt(tempArray[selected]["PPH"]) > 0) {
                PPHTotal = parseFloat(
                  totals -
                    (totals -
                      (totals * parseInt(tempArray[selected]["PPH"])) / 100)
                ).toFixed(2);
              }
              if (parseInt(tempArray[selected]["PBBKB"]) > 0) {
                PBBKBTotal = parseFloat(
                  totals -
                    (totals -
                      (totals * parseInt(tempArray[selected]["PBBKB"])) / 100)
                ).toFixed(2);
              }
              tempArray[selected]["PPNTotal"] = parseFloat(PPNTotal).toFixed(2);
              tempArray[selected]["PPHTotal"] = parseFloat(PPHTotal).toFixed(2);
              tempArray[selected]["PBBKBTotal"] =
                parseFloat(PBBKBTotal).toFixed(2);
              tempArray[selected]["GTOTAL"] = parseFloat(
                parseInt(totals) +
                  (parseInt(PPNTotal) +
                    parseInt(PPHTotal) +
                    parseInt(PBBKBTotal)) +
                  // Biaya Lain-lain PC: di luar biaya utama, setelah pajak.
                  (parseFloat(tempArray[selected]["BiayaLain"]) || 0)
              ).toFixed(2);
              setGeneralTotal(
                parseInt(tempArray[selected]["GTOTAL"]) + parseInt(generalTotal)
              );
            }
        }
        setPRListComparison(tempArray);
      }
    }
  }, [barang]);

  useEffect(() => {
    var tempArray = [];
    if (PurchaseRequisition.data) {
      if (PurchaseRequisition.data.data) {
        PurchaseRequisition.data.data.map((datas, i) => {
          tempArray.push({
            ...datas,
            value: i,
            label: datas.PurchaseRequisitionID,
          });
        });
      }
    }
    setPRData(tempArray);
  }, [PurchaseRequisition.data]);

  let user = JSON.parse(localStorage.getItem("user"));

  const getDataFromURL = (url) =>
    new Promise((resolve, reject) => {
      url = url.replaceAll("/", "-");
      setTimeout(() => {
        fetch(
          process.env.REACT_APP_API_URL +
            "Procurement/FilePriceComparison/" +
            url,
          {
            method: "GET", // or 'PUT'
            headers: {
              Accept: "*/*",
              Authorization: "Bearer " + user.Token,
            },
          }
        )
          .then((response) => response.blob())
          .then((data) => {
            const file = window.URL.createObjectURL(data);
            window.open(file);
          });
      });
    }, 2000);

  const header = [
    { name: "Barang", key: "BarangID", modifiers: "Barang" },
    { name: "Qty", key: "Qty", modifiers: "number" },
    { name: "SDT Date", key: "SDTDate", modifiers: "dateOnlyNew" },
    { name: "Specification", key: "Specification", modifiers: "Text" },
  ];

  const PRHandler = (value, names) => {
    customHandler(value, names);
    PurchaseRequisitionDetail.mutate(prData[value]["PurchaseRequisitionID"]);
  };

  const SupplierCount = (e) => {
    changeHandler(e);
    let detailArray = [];
    if (PurchaseRequisitionDetail.data) {
      PurchaseRequisitionDetail.data.data.PRList.map((detail, i) => {
        detailArray.push({
          ...detail,
          Harga: 0,
          DiscountPercent: 0,
          DiscountRupiah: 0,
          Merk: "",
          PilihanBeli: false,
        });
      });
    }
    if (e.target.value && e.target.value > 0) {
      let TempArray = [];
      for (let i = 1; i <= e.target.value; i++) {
        const obj = {
          TanggalKirim: new Date(),
          PPN: 0,
          PPH: 0,
          PBBKB: 0,
          PRListComparison: detailArray,
        };
        TempArray.push(obj);
      }
      if (PurchaseRequisitionDetail.data) {
        setPRListComparison(TempArray);
      }
    }
  };

  const PurchaseRequisitionDetailEditor = (ids, i, e, len) => {
    let tempArray = JSON.parse(JSON.stringify(pRListComparison));
    const selected = ids;
    let valuesTarget = e.target.value;
    if (e.target.name === "PilihanBeli") {
      valuesTarget = e.target.checked;
    }

    for (let j = 0; j < pRListComparison.length; j++) {
      if (valuesTarget) {
        tempArray[j]["PRListComparison"][i][e.target.name] = false;
      }
    }
    tempArray[selected]["PRListComparison"][i][e.target.name] = valuesTarget;

    setPRListComparison([...tempArray]);
  };

  const SupplierBuilder = () => {
    let returnArray = [];
    if (values.SupplierCount && values.SupplierCount > 0) {
      for (let i = 1; i <= values.SupplierCount; i++) {
        returnArray.push(
          <li key={i} className="mr-2" role="presentation">
            <button
              onClick={() => {
                setSupplierSelected(i);
              }}
              className={
                supplierSelected === i
                  ? "inline-block p-4 rounded-t-lg border-b-2 text-main-100 border-main-100 bg-gray-200"
                  : "inline-block p-4 rounded-t-lg border-b-2 "
              }
              type="button"
              role="tab"
              aria-selected="false"
            >
              Detail Supplier - {i}
            </button>
          </li>
        );
      }
    }
    return returnArray;
  };

  useEffect(() => {
    if (mutationSave) {
      if (mutationSave.isSuccess) {
        navigate("/procurment/report/price-comparison");
      }
    }
  }, [mutationSave.status]);

  const Kirim = (type) => {
    const newValues = {
      MPRComparisonID: params.transid.replaceAll("-", "/"),
    };
    mutationSave.mutate(newValues);
  };

  function prEditor(name, ids, e) {
    var temp = pRListComparison;
    temp[ids][name] = e;
    setPRListComparison([...temp]);
  }

  return (
    <div className="md:ml-64">
      <div
        style={{ background: Colors.primary }}
        className="pt-14 pb-16 px-3 md:px-8 h-auto"
      >
        <div className="container mx-auto max-w-full">
          <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
        </div>
      </div>
      <div className="px-3 md:px-8 h-auto -mt-32">
        <div className="container mx-auto max-w-full">
          <div className="grid grid-cols-1 px-4">
            <Card>
              <div className="flex flex-col  mt-5">
                <div className="flex w-full justify-end flex-col sm:flex-row ">
                  <button
                    onClick={() =>
                      navigate("/procurment/report/price-comparison")
                    }
                    className="flex flex-row items-center justify-center m-2 sm:my-0 bg-white hover:bg-main-100 hover:text-white text-gray-800 font-semibold py-2 px-4 border border-main-100 shadow rounded"
                  >
                    <BiArrowBack className="text-xl text-gray-800 pr-2" />
                    Kembali
                  </button>

                  <button
                    onClick={() => Kirim(2)}
                    className="bg-red-400 flex flex-row items-center justify-center m-2 sm:my-0 bg-white hover:bg-main-100 hover:text-white text-gray-800 font-semibold py-2 px-4 border border-main-100 shadow rounded"
                  >
                    {mutationAdd.isLoading ? (
                      <>
                        <svg
                          aria-hidden="true"
                          role="status"
                          className="inline mr-3 w-4 h-4 text-white animate-spin"
                          viewBox="0 0 100 101"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                            fill="#E5E7EB"
                          />
                          <path
                            d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                            fill="current
                                       Color"
                          />
                        </svg>
                        Loading
                      </>
                    ) : (
                      "Tolak"
                    )}
                  </button>
                </div>
                <div className="w-1/3"></div>
                {PurchaseRequisition.data ? (
                  <>
                    <div className={"row-auto"}>
                      <div className={"w-full md:w-1/3 px-3 mb-5"}>
                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                          No. PR
                        </label>
                        <Select
                          value={prData.filter(
                            ({ value }) =>
                              value === values["PurchaseRequisitionID"]
                          )}
                          isDisabled={true}
                          name={"PurchaseRequisitionID"}
                          className={
                            (touched["PurchaseRequisitionID"] ||
                              buttonTouched) &&
                            errors["PurchaseRequisitionID"]
                              ? "appearance-none block w-full  text-gray-700 border border-red-500  outline-none bg-white"
                              : "appearance-none block w-full  text-gray-700 border border-gray-200  outline-none bg-white border-gray-500"
                          }
                          onChange={(text) =>
                            PRHandler(text.value, "PurchaseRequisitionID")
                          }
                          options={prData}
                        />
                      </div>
                      {prData[values["PurchaseRequisitionID"]] && (
                        <div className={"w-full md:w-1/3 px-3 mb-5"}>
                          <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                            Tanggal
                          </label>
                          <div
                            className={
                              "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                            }
                          >
                            {new Date(
                              prData[values["PurchaseRequisitionID"]]["DatePR"]
                            )
                              .toISOString()
                              .substring(0, 10)}
                          </div>
                        </div>
                      )}
                      {prData[values["PurchaseRequisitionID"]] && (
                        <div className={"w-full md:w-1/2 px-3 mb-5"}>
                          <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                            Remarks
                          </label>
                          <div
                            className={
                              "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                            }
                          >
                            {prData[values["PurchaseRequisitionID"]]["Remarks"]}
                          </div>
                        </div>
                      )}
                    </div>
                  </>
                ) : (
                  <button className="w-full md:w-1/3 px-3 mb-5 bg-main-100 p-2">
                    <svg
                      aria-hidden="true"
                      role="status"
                      className="inline mr-3 w-4 h-4 text-white animate-spin"
                      viewBox="0 0 100 101"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                        fill="#E5E7EB"
                      />
                      <path
                        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                        fill="current
                                       Color"
                      />
                    </svg>
                    Loading
                  </button>
                )}
                <div className="w-1/4">
                  <HrdInputGenerator
                    type={"number"}
                    value={values}
                    name={"SupplierCount"}
                    title={"Jumlah Supplier"}
                    onChange={SupplierCount}
                    touched={touched}
                    buttonTouched={buttonTouched}
                    size={"full"}
                    required={true}
                    errors={errors}
                    disabled={true}
                  />
                </div>
                <hr />
                {PurchaseRequisitionDetail.isLoading ? (
                  <Skeltons />
                ) : (
                  <DynamicTableSimple
                    data={barang}
                    header={header}
                    OnClick={ModalOpener}
                    name={"Purchase Requisition"}
                    barang={barangDetail.data}
                  />
                )}

                <hr className={"my-5"} />

                <div className="mb-4 border-b border-gray-200 dark:border-gray-700">
                  <ul
                    className="flex flex-wrap -mb-px text-sm font-medium text-center"
                    id="myTab"
                    data-tabs-toggle="#myTabContent"
                    role="tablist"
                  >
                    {<SupplierBuilder />}
                    <li key={-1} className="mr-2" role="presentation">
                      <button
                        onClick={() => {
                          setSupplierSelected(-1);
                        }}
                        className={
                          supplierSelected === -1
                            ? "inline-block p-4 rounded-t-lg border-b-2 text-main-100 border-main-100 bg-gray-200"
                            : "inline-block p-4 rounded-t-lg border-b-2 "
                        }
                        type="button"
                        role="tab"
                        aria-selected="false"
                      >
                        Komparasi
                      </button>
                    </li>
                    <li key={"Show hide"} className="mr-2" role="presentation">
                      <button
                        className="inline-block p-4 rounded-t-lg border-b-2 bg-main-100 "
                        onClick={(e) => setshowDetail(!showDetail)}
                      >
                        {showDetail ? "Hide" : "Show"} Supplier Data
                      </button>
                    </li>
                  </ul>
                  {PurchaseRequisitionDetail.isLoading ? (
                    <Skeltons />
                  ) : (
                    <>
                      {pRListComparison &&
                        pRListComparison.map((cats, ids) => {
                          if (ids === supplierSelected - 1) {
                            return (
                              <div key={"Main" + ids} className={"mt-10"}>
                                {showDetail && (
                                  <div className={"text-left items-start"}>
                                    <div className="grid gap-6 mb-6 md:grid-cols-3 px-3 my-4">
                                      <div>
                                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                          Name
                                        </label>
                                        <input
                                          type="text"
                                          value={cats["NamaSupplier"]}
                                          name={"NamaSupplier"}
                                          disabled={true}
                                          className={
                                            "appearance-none block w-full text-left text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                          }
                                          onChange={(e) => {
                                            prEditor(
                                              "NamaSupplier",
                                              ids,
                                              e.target.value
                                            );
                                          }}
                                        />
                                      </div>
                                      <div>
                                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                          Tanggal Kirim
                                        </label>
                                        <DatePicker
                                          utcOffset={0}
                                          dateFormat="dd/MMMM/yyyy"
                                          timeFormat={"dd/MMMM/yyyy "}
                                          disabled={true}
                                          selected={
                                            new Date(cats["TanggalKirim"])
                                          }
                                          className={
                                            "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                          }
                                          onChange={(text) =>
                                            prEditor("Currency", ids, text)
                                          }
                                        />
                                      </div>
                                    </div>
                                    <div className="grid gap-6 mb-6 md:grid-cols-3 px-3 my-4">
                                      <div>
                                        <label className="block mb-2 text-sm font-medium text-gray-900 uppercase">
                                          Franco
                                        </label>
                                        {franco.data && (
                                          <Select
                                            value={franco.data.data.filter(
                                              ({ value }) =>
                                                value === cats["FrancoID"]
                                            )}
                                            isDisabled={true}
                                            name={"FrancoID"}
                                            className={
                                              "appearance-none block w-full  text-gray-700 border border-gray-200  outline-none bg-white border-gray-500"
                                            }
                                            onChange={(text) =>
                                              prEditor(
                                                "FrancoID",
                                                ids,
                                                text.value
                                              )
                                            }
                                            options={franco.data.data}
                                          />
                                        )}
                                      </div>

                                      <div>
                                        <label className="block mb-2 text-sm font-medium text-gray-900 uppercase">
                                          TOP
                                        </label>
                                        <Select
                                          value={Top.filter(
                                            ({ value }) => value === cats["TOP"]
                                          )}
                                          isDisabled={true}
                                          name={"TOP"}
                                          className={
                                            "appearance-none block w-full  text-gray-700 border border-gray-200  outline-none bg-white border-gray-500"
                                          }
                                          onChange={(text) =>
                                            prEditor("TOP", ids, text.value)
                                          }
                                          options={Top}
                                        />
                                      </div>
                                      <div>
                                        <label className="block mb-2 text-sm font-medium text-gray-900 uppercase">
                                          Currency
                                        </label>
                                        <Select
                                          value={Currency.filter(
                                            ({ value }) =>
                                              value === cats["Currency"]
                                          )}
                                          isDisabled={true}
                                          name={"Currency"}
                                          className={
                                            "appearance-none block w-full  text-gray-700 border border-gray-200  outline-none bg-white border-gray-500"
                                          }
                                          onChange={(text) =>
                                            prEditor(
                                              "Currency",
                                              ids,
                                              text.value
                                            )
                                          }
                                          options={Currency}
                                        />
                                      </div>
                                    </div>
                                    <div className="grid gap-6 mb-6 md:grid-cols-3 px-3 my-4">
                                      <div>
                                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                          Discound %
                                        </label>
                                        <input
                                          disabled={true}
                                          type="number"
                                          max={100}
                                          value={cats["DiscountPercent"]}
                                          name={"DiscountPercent"}
                                          className={
                                            "appearance-none block w-full text-left text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                          }
                                          onChange={(e) => {
                                            prEditor(
                                              "DiscountPercent",
                                              ids,
                                              e.target.value
                                            );
                                          }}
                                        />
                                      </div>
                                      <div>
                                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                          Discound Rp
                                        </label>
                                        <input
                                          disabled={true}
                                          type="number"
                                          value={cats["DiscountRupiah"]}
                                          name={"DiscountRupiah"}
                                          className={
                                            "appearance-none block w-full text-left text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                          }
                                          onChange={(e) => {
                                            prEditor(
                                              "DiscountRupiah",
                                              ids,
                                              e.target.value
                                            );
                                          }}
                                        />
                                      </div>
                                    </div>
                                    <div className="grid gap-6 mb-6 md:grid-cols-3 px-3 my-4">
                                      <div>
                                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                          PPN %
                                        </label>
                                        <input
                                          disabled={true}
                                          type="number"
                                          max={100}
                                          value={cats["PPN"]}
                                          name={"PPN"}
                                          className={
                                            "appearance-none block w-full text-left text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                          }
                                          onChange={(e) => {
                                            prEditor(
                                              "PPN",
                                              ids,
                                              e.target.value
                                            );
                                          }}
                                        />
                                      </div>
                                      <div>
                                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                          PPH %
                                        </label>
                                        <input
                                          disabled={true}
                                          type="number"
                                          max={100}
                                          value={cats["PPH"]}
                                          name={"PPH"}
                                          className={
                                            "appearance-none block w-full text-left text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                          }
                                          onChange={(e) => {
                                            prEditor(
                                              "PPH",
                                              ids,
                                              e.target.value
                                            );
                                          }}
                                        />
                                      </div>
                                    </div>

                                    <div className="grid gap-6 mb-6 px-3 my-4">
                                      <div>
                                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                          Term of condition
                                        </label>
                                        <textarea
                                          type="text"
                                          value={cats["TOC"]}
                                          name={"TOC"}
                                          className={
                                            "appearance-none block w-full text-left text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500 h-20"
                                          }
                                          onChange={(e) => {
                                            prEditor(
                                              "TOC",
                                              ids,
                                              e.target.value
                                            );
                                          }}
                                        />
                                      </div>
                                    </div>
                                    {cats["NamaFile"] && (
                                      <div className="grid gap-6 mb-6 px-3 my-4">
                                        <div className="w-1/2">
                                          <label className="block uppercase  tracking-wide text-gray-700 text-xs font-bold mb-2">
                                            Data pendukung terupload *
                                          </label>

                                          <a
                                            onClick={() =>
                                              getDataFromURL(cats["NamaFile"])
                                            }
                                            className="flex flex-row  mt-1 items-center bg-white hover:bg-gray-100 text-gray-800 font-semibold py-1 px-4 border border-gray-400 rounded shadow"
                                          >
                                            <BiPrinter className="text-xl text-gray-800 mr-2" />
                                            <span>{cats["NamaFile"]}</span>
                                          </a>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                )}
                                <table className="table-auto w-full text-sm text-left text-gray-500 dark:text-gray-400 mt-10">
                                  <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400 ">
                                    <tr>
                                      <th
                                        scope="col"
                                        className="py-3 px-6"
                                        rowSpan={2}
                                      >
                                        Barang
                                      </th>
                                      <th
                                        scope="col"
                                        className="py-3 px-6"
                                        rowSpan={2}
                                      >
                                        Harga
                                      </th>
                                      <th
                                        scope="col"
                                        className="py-3 px-6 text-center border-b"
                                        colSpan={2}
                                      >
                                        Discound
                                      </th>

                                      <th
                                        scope="col"
                                        className="py-3 px-6"
                                        rowSpan={2}
                                      >
                                        Merk
                                      </th>
                                      <th
                                        scope="col"
                                        className="py-3 px-6"
                                        rowSpan={2}
                                      >
                                        Total Harga
                                      </th>
                                      <th
                                        scope="col"
                                        className="py-3 px-6"
                                        rowSpan={2}
                                      >
                                        Pilihan Beli
                                      </th>
                                    </tr>
                                    <tr>
                                      <th
                                        scope="col"
                                        className="py-3 px-6 text-center"
                                      >
                                        %
                                      </th>
                                      <th
                                        scope="col"
                                        className="py-3 px-6 text-center"
                                      >
                                        Rp
                                      </th>
                                    </tr>
                                  </thead>

                                  <>
                                    {cats["PRListComparison"] &&
                                      cats["PRListComparison"].map(
                                        (detail, id) => {
                                          let classOdd =
                                            "bg-gray-50 border-b  hover:bg-gray-200 hover:text-main-100";
                                          if (id % 2 === 0)
                                            classOdd =
                                              "bg-white border-b  hover:bg-gray-200 hover:text-main-100";
                                          let texts = "";
                                          if (barangDetail.data) {
                                            const val =
                                              barangDetail.data.data.filter(
                                                ({ value }) =>
                                                  value === detail.BarangID
                                              );
                                            if (val[0]) {
                                              texts = val[0]["label"];
                                            }
                                          }
                                          return (
                                            <tr
                                              key={
                                                id + "rows" + supplierSelected
                                              }
                                              className={classOdd}
                                            >
                                              <th
                                                scope="row"
                                                key={
                                                  supplierSelected -
                                                  1 +
                                                  "rowt" +
                                                  id
                                                }
                                                className={
                                                  "py-4 px-6 font-medium whitespace-nowrap "
                                                }
                                              >
                                                {texts}
                                              </th>
                                              <th
                                                scope="row"
                                                key={
                                                  supplierSelected -
                                                  1 +
                                                  "rowHarga" +
                                                  id
                                                }
                                                className={
                                                  "py-4 px-6 font-medium whitespace-nowrap "
                                                }
                                              >
                                                <input
                                                  type="number"
                                                  value={detail["Harga"]}
                                                  name={"Harga"}
                                                  disabled={true}
                                                  className={
                                                    "appearance-none block w-full text-right text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                                  }
                                                  onChange={(e) => {
                                                    PurchaseRequisitionDetailEditor(
                                                      ids,
                                                      id,
                                                      e,
                                                      cats.length
                                                    );
                                                  }}
                                                />
                                              </th>
                                              <th
                                                scope="row"
                                                key={
                                                  supplierSelected -
                                                  1 +
                                                  "rownumber" +
                                                  id
                                                }
                                                className={
                                                  "py-4 px-6 font-medium whitespace-nowrap "
                                                }
                                              >
                                                <input
                                                  type="number"
                                                  value={
                                                    detail["DiscountPercent"]
                                                  }
                                                  max={"100"}
                                                  disabled={true}
                                                  name={"DiscountPercent"}
                                                  className={
                                                    "appearance-none block w-full text-right text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                                  }
                                                  onChange={(e) => {
                                                    PurchaseRequisitionDetailEditor(
                                                      ids,
                                                      id,
                                                      e,
                                                      cats.length
                                                    );
                                                  }}
                                                />
                                              </th>
                                              <th
                                                scope="row"
                                                key={
                                                  supplierSelected -
                                                  1 +
                                                  "rownumbers" +
                                                  id
                                                }
                                                className={
                                                  "py-4 px-6 font-medium whitespace-nowrap "
                                                }
                                              >
                                                <input
                                                  type="number"
                                                  disabled={true}
                                                  value={
                                                    detail["DiscountRupiah"]
                                                  }
                                                  name={"DiscountRupiah"}
                                                  className={
                                                    "appearance-none block w-full text-right text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                                  }
                                                  onChange={(e) => {
                                                    PurchaseRequisitionDetailEditor(
                                                      ids,
                                                      id,
                                                      e,
                                                      cats.length
                                                    );
                                                  }}
                                                />
                                              </th>
                                              <th
                                                scope="row"
                                                key={
                                                  supplierSelected -
                                                  1 +
                                                  "rowMerk" +
                                                  id
                                                }
                                                className={
                                                  "py-4 px-6 font-medium whitespace-nowrap "
                                                }
                                              >
                                                <input
                                                  type="text"
                                                  disabled={true}
                                                  value={detail["Merk"]}
                                                  name={"Merk"}
                                                  className={
                                                    "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                                  }
                                                  onChange={(e) => {
                                                    PurchaseRequisitionDetailEditor(
                                                      ids,
                                                      id,
                                                      e,
                                                      cats.length
                                                    );
                                                  }}
                                                />
                                              </th>
                                              <th
                                                scope="row"
                                                key={
                                                  supplierSelected -
                                                  1 +
                                                  "rowTotalHarga" +
                                                  id
                                                }
                                                className={
                                                  "py-4 px-6 font-medium whitespace-nowrap text-right"
                                                }
                                              >
                                                {parseFloat(
                                                  detail["TotalHarga"]
                                                ).toLocaleString("in-ID", {
                                                  maximumFractionDigits: 2,
                                                })}
                                              </th>
                                              <th
                                                scope="row"
                                                key={
                                                  supplierSelected -
                                                  1 +
                                                  "rowPilihanBeli" +
                                                  id
                                                }
                                                className={
                                                  "py-4 px-6 font-medium whitespace-nowrap "
                                                }
                                              >
                                                <input
                                                  type="checkbox"
                                                  value={true}
                                                  checked={
                                                    detail["PilihanBeli"]
                                                  }
                                                  disabled={true}
                                                  name={"PilihanBeli"}
                                                  className={
                                                    "w-4 h-4 text-main-100 bg-gray-100 rounded border-main-100"
                                                  }
                                                  onChange={(e) => {
                                                    PurchaseRequisitionDetailEditor(
                                                      ids,
                                                      id,
                                                      e,
                                                      cats.length
                                                    );
                                                  }}
                                                />
                                              </th>
                                            </tr>
                                          );
                                        }
                                      )}
                                    <>
                                      <tr
                                        className={
                                          "table-auto w-full text-sm text-left text-gray-500 dark:text-gray-400 mt-10"
                                        }
                                      >
                                        <th
                                          scope="row"
                                          colSpan={5}
                                          className={
                                            "py-4 px-6 font-medium whitespace-nowrap text-right"
                                          }
                                        >
                                          Total 1
                                        </th>
                                        <th
                                          scope="row"
                                          className={
                                            "py-4 px-6 font-medium whitespace-nowrap text-right"
                                          }
                                        >
                                          {parseFloat(
                                            cats["Total"]
                                          ).toLocaleString("in-ID", {
                                            maximumFractionDigits: 2,
                                          })}
                                        </th>
                                        <th
                                          scope="row"
                                          key={
                                            supplierSelected -
                                            1 +
                                            "rowPilihanBeliGT"
                                          }
                                          className={
                                            "py-4 px-6 font-medium whitespace-nowrap "
                                          }
                                        ></th>
                                      </tr>
                                      <tr
                                        className={
                                          "table-auto w-full text-sm text-left text-gray-500 dark:text-gray-400 mt-10"
                                        }
                                      >
                                        <th
                                          scope="row"
                                          colSpan={5}
                                          className={
                                            "py-4 px-6 font-medium whitespace-nowrap text-right"
                                          }
                                        >
                                          Discound
                                        </th>
                                        <th
                                          scope="row"
                                          className={
                                            "py-4 px-6 font-medium whitespace-nowrap text-right"
                                          }
                                        >
                                          {parseFloat(
                                            cats["Discound"]
                                          ).toLocaleString("in-ID", {
                                            maximumFractionDigits: 2,
                                          })}
                                        </th>
                                        <th
                                          scope="row"
                                          key={
                                            supplierSelected -
                                            1 +
                                            "rowPilihanBeliGT"
                                          }
                                          className={
                                            "py-4 px-6 font-medium whitespace-nowrap "
                                          }
                                        ></th>
                                      </tr>
                                      <tr
                                        className={
                                          "table-auto w-full text-sm text-left text-gray-500 dark:text-gray-400 mt-10"
                                        }
                                      >
                                        <th
                                          scope="row"
                                          colSpan={5}
                                          className={
                                            "py-4 px-6 font-medium whitespace-nowrap text-right"
                                          }
                                        >
                                          Total 2
                                        </th>
                                        <th
                                          scope="row"
                                          className={
                                            "py-4 px-6 font-medium whitespace-nowrap text-right"
                                          }
                                        >
                                          {parseFloat(
                                            cats["Total2"]
                                          ).toLocaleString("in-ID", {
                                            maximumFractionDigits: 2,
                                          })}
                                        </th>
                                        <th
                                          scope="row"
                                          key={
                                            supplierSelected -
                                            1 +
                                            "rowPilihanBeliGT"
                                          }
                                          className={
                                            "py-4 px-6 font-medium whitespace-nowrap "
                                          }
                                        ></th>
                                      </tr>
                                      <tr
                                        className={
                                          "table-auto w-full text-sm text-left text-gray-500 dark:text-gray-400 mt-10"
                                        }
                                      >
                                        <th
                                          scope="row"
                                          colSpan={5}
                                          className={
                                            "py-4 px-6 font-medium whitespace-nowrap text-right"
                                          }
                                        >
                                          PPN
                                        </th>
                                        <th
                                          scope="row"
                                          className={
                                            "py-4 px-6 font-medium whitespace-nowrap text-right"
                                          }
                                        >
                                          {parseFloat(
                                            cats["PPNTotal"]
                                          ).toLocaleString("in-ID", {
                                            maximumFractionDigits: 2,
                                          })}
                                        </th>
                                        <th
                                          scope="row"
                                          key={
                                            supplierSelected -
                                            1 +
                                            "rowPilihanBeliGT"
                                          }
                                          className={
                                            "py-4 px-6 font-medium whitespace-nowrap "
                                          }
                                        ></th>
                                      </tr>
                                      <tr
                                        className={
                                          "table-auto w-full text-sm text-left text-gray-500 dark:text-gray-400 mt-10"
                                        }
                                      >
                                        <th
                                          scope="row"
                                          colSpan={5}
                                          className={
                                            "py-4 px-6 font-medium whitespace-nowrap text-right"
                                          }
                                        >
                                          PPH
                                        </th>
                                        <th
                                          scope="row"
                                          className={
                                            "py-4 px-6 font-medium whitespace-nowrap text-right"
                                          }
                                        >
                                          {parseFloat(
                                            cats["PPHTotal"]
                                          ).toLocaleString("in-ID", {
                                            maximumFractionDigits: 2,
                                          })}
                                        </th>
                                        <th
                                          scope="row"
                                          key={
                                            supplierSelected -
                                            1 +
                                            "rowPilihanBeliGT"
                                          }
                                          className={
                                            "py-4 px-6 font-medium whitespace-nowrap "
                                          }
                                        ></th>
                                      </tr>
                                      <tr
                                        className={
                                          "table-auto w-full text-sm text-left text-gray-500 dark:text-gray-400 mt-10"
                                        }
                                      >
                                        <th
                                          scope="row"
                                          colSpan={5}
                                          className={
                                            "py-4 px-6 font-medium whitespace-nowrap text-right"
                                          }
                                        >
                                          PBBKB
                                        </th>
                                        <th
                                          scope="row"
                                          className={
                                            "py-4 px-6 font-medium whitespace-nowrap text-right"
                                          }
                                        >
                                          {parseFloat(
                                            cats["PBBKBTotal"]
                                          ).toLocaleString("in-ID", {
                                            maximumFractionDigits: 2,
                                          })}
                                        </th>
                                        <th
                                          scope="row"
                                          key={
                                            supplierSelected -
                                            1 +
                                            "rowPilihanBeliGT"
                                          }
                                          className={
                                            "py-4 px-6 font-medium whitespace-nowrap "
                                          }
                                        ></th>
                                      </tr>
                                      <tr
                                        className={
                                          "table-auto w-full text-sm text-left text-gray-500 dark:text-gray-400 mt-10"
                                        }
                                      >
                                        <th
                                          scope="row"
                                          colSpan={5}
                                          className={
                                            "py-4 px-6 font-medium whitespace-nowrap text-right"
                                          }
                                        >
                                          Total
                                        </th>
                                        <th
                                          scope="row"
                                          className={
                                            "py-4 px-6 font-medium whitespace-nowrap text-right"
                                          }
                                        >
                                          {parseFloat(
                                            cats["GTOTAL"]
                                          ).toLocaleString("in-ID", {
                                            maximumFractionDigits: 2,
                                          })}
                                        </th>
                                        <th
                                          scope="row"
                                          key={
                                            supplierSelected -
                                            1 +
                                            "rowPilihanBeliGT"
                                          }
                                          className={
                                            "py-4 px-6 font-medium whitespace-nowrap "
                                          }
                                        ></th>
                                      </tr>
                                    </>
                                  </>
                                </table>
                              </div>
                            );
                          }
                        })}
                      {supplierSelected === -1 && (
                        <div key={"Main-1"} className={"mt-10"}>
                          <table className="table-auto w-full scroll-auto text-sm text-left text-gray-500 dark:text-gray-400 mt-10">
                            <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400 ">
                              <tr>
                                <th
                                  scope="col"
                                  className="py-3 px-6"
                                  rowSpan={2}
                                >
                                  Barang
                                </th>
                                <th
                                  scope="col"
                                  className="py-3 px-6"
                                  rowSpan={2}
                                >
                                  Harga
                                </th>
                                {pRListComparison &&
                                  pRListComparison.map((cats, ids) => {
                                    return (
                                      <>
                                        <th
                                          scope="col"
                                          className="py-3 px-6 text-center border-b"
                                          colSpan={2}
                                        >
                                          Discound
                                        </th>

                                        <th
                                          scope="col"
                                          className="py-3 px-6"
                                          rowSpan={2}
                                        >
                                          Merk
                                        </th>
                                        <th
                                          scope="col"
                                          className="py-3 px-6"
                                          rowSpan={2}
                                        >
                                          Total Harga
                                        </th>
                                        <th
                                          scope="col"
                                          className="py-3 px-6"
                                          rowSpan={2}
                                        >
                                          X
                                        </th>
                                      </>
                                    );
                                  })}
                              </tr>
                              <tr>
                                {pRListComparison &&
                                  pRListComparison.map((cats, ids) => {
                                    return (
                                      <>
                                        <th
                                          scope="col"
                                          className="py-3 px-6 text-center"
                                        >
                                          %
                                        </th>
                                        <th
                                          scope="col"
                                          className="py-3 px-6 text-center"
                                        >
                                          Rp
                                        </th>
                                      </>
                                    );
                                  })}
                              </tr>
                            </thead>

                            {pRListComparison &&
                              pRListComparison.map((cats, ids) => {
                                return (
                                  <>
                                    {cats["PRListComparison"] &&
                                      cats["PRListComparison"].map(
                                        (detail, id) => {
                                          let texts = "";
                                          if (barangDetail.data) {
                                            const val =
                                              barangDetail.data.data.filter(
                                                ({ value }) =>
                                                  value === detail.BarangID
                                              );
                                            if (val[0]) {
                                              texts = val[0]["label"];
                                            }
                                          }
                                          return (
                                            <>
                                              {ids === 0 ? (
                                                <th
                                                  scope="row"
                                                  key={
                                                    supplierSelected -
                                                    1 +
                                                    "rowt" +
                                                    id
                                                  }
                                                  className={
                                                    "py-4 px-6 font-medium whitespace-nowrap "
                                                  }
                                                >
                                                  {texts}
                                                </th>
                                              ) : (
                                                <></>
                                              )}
                                              {ids === 0 ? (
                                                <th
                                                  scope="row"
                                                  key={
                                                    supplierSelected -
                                                    1 +
                                                    "rowHarga" +
                                                    id
                                                  }
                                                  className={
                                                    "py-4 px-6 font-medium whitespace-nowrap "
                                                  }
                                                >
                                                  <input
                                                    type="number"
                                                    value={detail["Harga"]}
                                                    name={"Harga"}
                                                    disabled={true}
                                                    className={
                                                      "appearance-none block w-full text-right text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                                    }
                                                    onChange={(e) => {
                                                      PurchaseRequisitionDetailEditor(
                                                        ids,
                                                        id,
                                                        e,
                                                        cats.length
                                                      );
                                                    }}
                                                  />
                                                </th>
                                              ) : (
                                                <></>
                                              )}
                                              <th
                                                scope="row"
                                                key={
                                                  supplierSelected -
                                                  1 +
                                                  "rownumber" +
                                                  id
                                                }
                                                className={
                                                  "py-4 px-6 font-medium whitespace-nowrap "
                                                }
                                              >
                                                <input
                                                  type="number"
                                                  value={
                                                    detail["DiscountPercent"]
                                                  }
                                                  max={"100"}
                                                  disabled={true}
                                                  name={"DiscountPercent"}
                                                  className={
                                                    "appearance-none block w-full text-right text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                                  }
                                                  onChange={(e) => {
                                                    PurchaseRequisitionDetailEditor(
                                                      ids,
                                                      id,
                                                      e,
                                                      cats.length
                                                    );
                                                  }}
                                                />
                                              </th>
                                              <th
                                                scope="row"
                                                key={
                                                  supplierSelected -
                                                  1 +
                                                  "rownumbers" +
                                                  id
                                                }
                                                className={
                                                  "py-4 px-6 font-medium whitespace-nowrap "
                                                }
                                              >
                                                <input
                                                  type="number"
                                                  disabled={true}
                                                  value={
                                                    detail["DiscountRupiah"]
                                                  }
                                                  name={"DiscountRupiah"}
                                                  className={
                                                    "appearance-none block w-full text-right text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                                  }
                                                  onChange={(e) => {
                                                    PurchaseRequisitionDetailEditor(
                                                      ids,
                                                      id,
                                                      e,
                                                      cats.length
                                                    );
                                                  }}
                                                />
                                              </th>
                                              <th
                                                scope="row"
                                                key={
                                                  supplierSelected -
                                                  1 +
                                                  "rowMerk" +
                                                  id
                                                }
                                                className={
                                                  "py-4 px-6 font-medium whitespace-nowrap "
                                                }
                                              >
                                                <input
                                                  type="text"
                                                  disabled={true}
                                                  value={detail["Merk"]}
                                                  name={"Merk"}
                                                  className={
                                                    "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                                                  }
                                                  onChange={(e) => {
                                                    PurchaseRequisitionDetailEditor(
                                                      ids,
                                                      id,
                                                      e,
                                                      cats.length
                                                    );
                                                  }}
                                                />
                                              </th>
                                              <th
                                                scope="row"
                                                key={
                                                  supplierSelected -
                                                  1 +
                                                  "rowTotalHarga" +
                                                  id
                                                }
                                                className={
                                                  "py-4 px-6 font-medium whitespace-nowrap text-right"
                                                }
                                              >
                                                {parseFloat(
                                                  detail["TotalHarga"]
                                                ).toLocaleString("in-ID", {
                                                  maximumFractionDigits: 2,
                                                })}
                                              </th>
                                              <th
                                                scope="row"
                                                key={
                                                  supplierSelected -
                                                  1 +
                                                  "rowPilihanBeli" +
                                                  id
                                                }
                                                className={
                                                  "py-4 px-6 font-medium whitespace-nowrap "
                                                }
                                              >
                                                <input
                                                  type="checkbox"
                                                  value={true}
                                                  checked={
                                                    detail["PilihanBeli"]
                                                  }
                                                  disabled={true}
                                                  name={"PilihanBeli"}
                                                  className={
                                                    "w-4 h-4 text-main-100 bg-gray-100 rounded border-main-100"
                                                  }
                                                  onChange={(e) => {
                                                    PurchaseRequisitionDetailEditor(
                                                      ids,
                                                      id,
                                                      e,
                                                      cats.length
                                                    );
                                                  }}
                                                />
                                              </th>
                                            </>
                                          );
                                        }
                                      )}
                                  </>
                                );
                              })}
                          </table>
                        </div>
                      )}
                    </>
                  )}
                </div>
              </div>
            </Card>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeletePurchaseComparationPage;
